import React, { useEffect } from "react";
import ReactTooltip from "react-tooltip";
import { injectIntl } from "react-intl";

const actionMeta = {
  include: {
    icon: "icon-search",
    hoverMessage: "alpha.filterInclude"
  },
  exclude: {
    icon: "icon-ban-circle",
    hoverMessage: "alpha.filterExclude"
  }
};

function ToggleButton(props) {
  useEffect(() => {
    ReactTooltip.rebuild();
  });

  if (props.hide) {
    return "";
  }

  const buttonClass = `btn toggle-button ${
    props.selected ? "btn-inverse" : ""
  }`;

  const iconClass =
    actionMeta[props.action].icon + (props.selected ? " icon-white" : "");
  return (
    <span
      data-tip={props.intl.formatMessage({
        id: actionMeta[props.action].hoverMessage
      })}
      data-place="top"
    >
      <button
        className={buttonClass}
        type="button"
        disabled={props.selected}
        onClick={props.onToggle}
      >
        <i className={iconClass} />
      </button>
    </span>
  );
}

export default injectIntl(ToggleButton);
